(function(window, document, $, undefined){
  
  // -----------------------------------------------------------------------------------------------------
  // .full-width scrollbar bug fix
  // -----------------------------------------------------------------------------------------------------
  // fixes any full-width divs. 100vw ignores scrollbars so end up with horizontal scrollbar :(
  if($('.full-width').length>0) {
    $(window).on('resize',function(){
      $('.full-width').width($('body').innerWidth());
    }).trigger('resize');
  }

})(window, document, jQuery);
